import { render, staticRenderFns } from "./aiCourseRender.vue?vue&type=template&id=205033cb&scoped=true&"
import script from "./aiCourseRender.vue?vue&type=script&lang=js&"
export * from "./aiCourseRender.vue?vue&type=script&lang=js&"
import style0 from "./aiCourseRender.vue?vue&type=style&index=0&id=205033cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205033cb",
  null
  
)

export default component.exports